exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".line[data-v-256c3ee8]{padding:0 8px}[data-v-256c3ee8] .el-input-number--medium{width:100%}[data-v-256c3ee8] .el-input__inner{text-align:left}.rank-explain p[data-v-256c3ee8]{margin:0;font-size:13px;color:rgba(0,0,0,0.5)}[data-v-256c3ee8] .el-dialog__footer{padding:0}.dialog-footer[data-v-256c3ee8]{padding:20px;border-top:1px solid #e6ebf5}\n", ""]);

// exports
